import React, {useMemo} from 'react'
import apiClient from 'src/services/apiClient'
import AdherenceTabs, {AdherenceFetcher} from 'src/pages-new/analytics/AdherenceTabs'
import {
  AdherenceFilterConfig,
  AdherenceLabels,
  AdherenceTab,
  AdherenceTherapyType,
} from 'src/utils/adherenceCharts'

interface AdherenceTherapyPanelProps {
  patientId: string
  // from patientDetailConfiguration.analyticsAdherence, already resolved to its defaults
  tabs: AdherenceTab[]
  visibleFilters: AdherenceFilterConfig[]
  labels: AdherenceLabels
}

// "Aderenza terapia" of the doctor's patient detail > Analytics: adherence to the patient's
// therapies, with the same sections (Terapie / Altre terapie), filters, numbers and charts as the
// patient's own Analytics page (COMPLETED assumptions over every assumption due in the range).
export default function AdherenceTherapyPanel({patientId, tabs, visibleFilters, labels}: AdherenceTherapyPanelProps): JSX.Element {
  const fetchers: Record<AdherenceTherapyType, AdherenceFetcher> = useMemo(() => ({
    primary: (filters, setStatus) => apiClient.getPatientTherapiesAdherence(patientId, filters, setStatus),
    secondary: (filters, setStatus) => apiClient.getPatientSecondaryTherapiesAdherence(patientId, filters, setStatus),
  }), [patientId])

  return (
    <AdherenceTabs
      tabs={tabs}
      fetchers={fetchers}
      visibleFilters={visibleFilters}
      labels={labels}
      noSections={tabs.length === 0}
    />
  )
}
